import { useParams } from 'next/navigation';

import { decodeSearchTerm } from '../utils/searchTerm';

export const useOriginalSearchQuery = () => {
  const { searchquery } = useParams() ?? {};

  return decodeSearchTerm(typeof searchquery === 'string' ? searchquery : '');
};
